import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, HiddenFees, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownOrderController,
  type UnifiedPriceBreakdownOrderControllerProps
} from "./useUnifiedPriceBreakdown.Order.controller";
import { FranceTax } from "./banners/FranceTax";

export type UnifiedPriceBreakdownOrderProps = UnifiedPriceBreakdownOrderControllerProps;

export function UnifiedPriceBreakdownOrder(props: UnifiedPriceBreakdownOrderProps) {
  const { unifiedPriceBreakdown, isHungaryDepartingRyanAir, disclaimers, addedItems, expandedByDefault } =
    useUnifiedPriceBreakdownOrderController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        addedItems={addedItems}
        expandedByDefault={expandedByDefault}
      />
      <Disclaimers disclaimers={disclaimers} />
      <FranceTax />
      <Atol />
      <SIRF />
      <HiddenFees />
    </Stack>
  );
}
